import { Functions, httpsCallable } from 'firebase/functions';
import { CreateSubscriptionFnReq, CreateSubscriptionFnRes } from '@uploadcam/common';

type CreateSubscriptionResult = CreateSubscriptionFnRes;

export class CreateSubscriptionInteractor {
  private readonly createSubscriptionFn = httpsCallable<
    CreateSubscriptionFnReq,
    CreateSubscriptionFnRes
  >(this.functions, 'createSubscription');

  constructor(private readonly functions: Functions) {}

  public async execute(priceId: string): Promise<CreateSubscriptionResult> {
    const res = await this.createSubscriptionFn({ priceId });
    return res.data;
  }
}
